import React, { useState, useEffect , useContext } from "react";
import axios from "axios";
import {
    TextField,
    Paper,
    Box,
    AppBar,
    Toolbar,
    Typography,
    Button,
    Alert,
    Grid,
    Select,
    InputLabel,
    FormControl,
    MenuItem

} from "@mui/material"

import Header from "../Header";
import { NumericFormat,PatternFormat } from "react-number-format";
import CardGroup from "./CardGroup";
import ChartGroup from "./ChartGroup";
import { formatDate, formatDateText } from "../CommonFunctions";
import { parseISO,eachDayOfInterval, format } from "date-fns";
import {
  getAllActiveTenantsInfo,
  getFreeRoomsByDate,
  getCurrentInventory,
  getReportSummary,
  preProcess,
  getCurrentYearRevenueInDC,
  getCallLogsByDateRangeCalculations,
  fetchExpectedPaymentsInDC,
  fetchReceivedPaymentsInDC
} from "./DataConnections"
import { columnGroupsStateInitializer } from "@mui/x-data-grid/internals";
let last12Months=[];
const options = { month: 'short', day: 'numeric', year:'numeric' };
let totalMonthlyAmount=0;
let currentVacancy=0;
let avgRooms=0;
let repairs=0;
let inventoryCount=0;
const currentYearStart = formatDate(new Date(new Date().getFullYear(), 0, 1));
let totalAnnual=0;
let total_lastYear=0;
let totalMonthly_lastYear=0;
let totalCalls=0;
const now=new Date();
now.setDate(1);
const Dashboard=()=>{
  const currentDate=formatDate(new Date());

  const [searchStartDate,setSearchStartDate]=  useState(formatDate(now));
  const [searchEndDate,setSearchEndDate]=useState(formatDate(new Date()));
  const [reportSummary,setReportSummary] = useState([])
  const [occupancyReport,setOccupancyReport] = useState([]);
  const [annualReport,setAnnualReport] = useState([])
  const [lastYearThisMonthPaymentReport, setLastYearThisMonthPaymentReport] = useState([])
  const [callLogs, setCallLogs] = useState([]);
  const [expectedPayments, setExpectedPayments] = useState([]);
  const [receivedPayments, setReceivedPayments] = useState([]);

  

 
    const url=process.env.REACT_APP_SERVER_URL;
    useEffect(() => {
      getRevenueSummary(null, searchStartDate, searchEndDate);
      // setReportSummary(getReportSummary(null,searchStartDate,searchEndDate));
      getVacancyReportByDateRange(searchStartDate,searchEndDate);
      fetchExpectedPayments(searchStartDate, searchEndDate);
      fetchReceivedPayments(searchStartDate, searchEndDate);
      getCallLogsByDateRange(searchStartDate, searchEndDate);

    }, [searchStartDate,searchEndDate]);
    useEffect(() => {
      getLast12Months();
      
      getCurrentMonthTotalPayment()
      getCurrentDayvacancy();
      getActiveRepairs();
      getCurrentRequestedInventory();
      getCurrentYearRevenue(searchStartDate, searchEndDate);
      getCallLogsByDateRange(searchStartDate, searchEndDate);
      fetchExpectedPayments(searchStartDate, searchEndDate);
      fetchReceivedPayments(searchStartDate, searchEndDate);
      // getLastYearThisMonth();

    }, [currentDate]);
    const getRevenueSummary = async(e, searchStartDate, searchEndDate)=>{
      try{
        const resultArray = await getReportSummary(e, searchStartDate, searchEndDate);
        if(resultArray){
          setReportSummary(resultArray);
        }

      }
      catch(error){
        console.log(error);
      }
    }
    const getCurrentYearRevenue = async(searchStartDate, searchEndDate) =>{
       const response = await getCurrentYearRevenueInDC(searchStartDate, searchEndDate);
       if(response){
        setAnnualReport(response.resultArray);
        totalAnnual = response.totalThisYear;
        total_lastYear = response.totalLastYear;
       }
    }

    
    
    const getCurrentRequestedInventory = async() =>{
      try{
        const response=await getCurrentInventory();
        if(response){
          // console.log("in getCurrentRequestedInventory");
          // console.log(response)
          const data=response;
          let sum=0;
          for(let itr in data){
            const currentRow=data[itr];
            // console.log("currentRow.request " + currentRow.request)
            if(currentRow.request && currentRow.status!=="Discontinued"){

              sum+=parseInt(currentRow.request);
            }
          }
          
          inventoryCount=sum;
        }

      }catch(error){
        console.log(error)
  
      }
    }
    const getCurrentMonthTotalPayment =async()=>{
      try{
        const currentDate = new Date();
        const searchEndDate=formatDate(currentDate)
        currentDate.setDate(1);
        const searchStartDate=formatDate(currentDate);
        
          const response=await getAllActiveTenantsInfo(null,searchStartDate,searchEndDate);
          if(response){
            const resultArray=preProcess(response.data,searchStartDate,searchEndDate);
            let temp=0;
            for(let itr in resultArray){
              const currentRow=resultArray[itr];
              temp+=currentRow.amount;
            }
            totalMonthlyAmount=temp;


          }
  
      }
      catch(error){
        console.log(error)
  
      }
    }
    
    
    
    
    function getLast12Months() {
      const months = [];
      const currentDate = new Date();
      currentDate.setDate(1); // Set to the first day of the current month
  
      for (let i = 0; i < 12; i++) {
          const startDate = new Date(currentDate);
          let endDate = new Date(currentDate);
          if(i!==0){
          endDate.setMonth(endDate.getMonth() + 1);
          endDate.setDate(0); // Set to the last day of the previous month
          }
          else{
            endDate=new Date();
          }
          
  
          months.push({
              startDate: new Date(startDate),
              endDate: new Date(endDate),
          });
  
          // Move to the previous month
          currentDate.setMonth(currentDate.getMonth() - 1);
      }
  
      last12Months= months;
  }
  const getCurrentDayvacancy =async()=>{
    try{
      const startDate=formatDate(new Date());
      const endDate=formatDate(new Date())
        const response=await getFreeRoomsByDate(startDate,endDate);
        if(response){
          // const resultArray=preProcessVacancyData(response.data,startDate,endDate,response.rooms)
          // if(resultArray){
          //   console.log("resultArray")
          //   console.log(resultArray)
            currentVacancy=response.data[0].vacantRooms.length;
          // }
        }

    }
    catch(error){
      console.log(error)

    }
  }
  const getVacancyReportByDateRange =async(startDate,endDate)=>{
    try{
      
        const response=await getFreeRoomsByDate(startDate,endDate);
        // console.log(response)
        if(response){
          // console.log(response)
          let totalVacantRooms = 0;

        const data = response.data.map(item => {
          const vacantCount = item.vacantRooms ? item.vacantRooms.length : 0;
          totalVacantRooms += vacantCount;

          return {
            ...item,
            numberOfVacantRooms: vacantCount
          };
        });

        avgRooms = totalVacantRooms / data.length;
          
          setOccupancyReport(data)
        }

    }
    catch(error){
      console.log(error)

    }
  }
  const preProcessVacancyData = (data,startDate,endDate,rooms)=>{
    let myDict={};
    // console.log("start Date : " + startDate + " end date : " + endDate);
    const interval = {
      // start: new Date(startDate).toUTCString(),
      // end: new Date(endDate).toUTCString()
      start: parseISO(startDate),
      end: parseISO(endDate)
    };
    const dates = eachDayOfInterval(interval).map(date => format(date, 'yyyy-MM-dd'));
    const result = {};
    dates.forEach(date => {
      result[date] = [];
    });      
Object.entries(data).forEach(([roomId, tenancies]) => {
  
  tenancies.forEach(tenancy => {
    const checkInDate = format(parseISO(tenancy.checkin), 'yyyy-MM-dd');
    let checkoutDate=null;
    if(tenancy.actualCheckoutDate===null){

    }
    else{
      checkoutDate = format(parseISO(tenancy.actualCheckoutDate), 'yyyy-MM-dd');
    }

    dates.forEach(date => {
      if(checkoutDate===null){
        if (date >= checkInDate) {
          result[date].push(parseInt(roomId));
        }
      }
      else{
        if (date >= checkInDate && date < checkoutDate) {
          result[date].push(parseInt(roomId));
        }
      }
      
    });
  });
});
const resultArray=[];
avgRooms=0;
for(let key in result){
  const occupiedRooms=result[key];
  const date=parseISO(key);
  

  const vacantRooms= rooms.filter(row => !occupiedRooms.includes(row.id));
  let lostRent=0;
  vacantRooms.map((row)=>{
    lostRent +=row.dailyRate;
  })
  avgRooms=avgRooms + vacantRooms.length
  resultArray.push({
    date:date.toLocaleDateString('en-US',{ month: 'short', day: 'numeric' }),
    occupiedRooms:occupiedRooms,
    vacantRooms:vacantRooms,
    lostRent:lostRent,
    numberOfVacantRooms:vacantRooms.length
  })

}
avgRooms = avgRooms/resultArray.length;

// console.log("Average rooms vacant: " + avgRooms)


return resultArray;

  }
   const getActiveRepairs = async() =>{
    const targetValue="Incomplete";
    const response= await axios.post(`${url}/repairs/searchRepairByStatus`,{
      targetValue
    });
    if(response){
      // console.log(response)
      repairs=response.data.length;
    }
   }

   const getCallLogsByDateRange = async(searchStartDate, searchEndDate) =>{
         try{
           const response = await getCallLogsByDateRangeCalculations(searchStartDate, searchEndDate);
           if(response){
             setCallLogs(response.resultArray);
             totalCalls= response.totalCalls;
           }
       
         }catch(error){
           console.log(error)
           
         }
    }

    const fetchExpectedPayments = async(searchStartDate, searchEndDate) =>{
      try{
        const response = await fetchExpectedPaymentsInDC(searchStartDate, searchEndDate);
        if(response){
          setExpectedPayments(response);
        }

      }
      catch(error){
        console.log(error)
           
      }
    }
    const fetchReceivedPayments = async(searchStartDate, searchEndDate) =>{
      try{
        const response = await fetchReceivedPaymentsInDC(searchStartDate, searchEndDate);
        if(response){
          setReceivedPayments(response);
        }

      }
      catch(error){
        console.log(error)
           
      }
    }
    
    
    

    return (
      <>
      <Header/>
      <Box sx={{  padding:"0% 4%",backgroundColor:"rgb(250, 250, 251)" }}>
      {/* <Grid container alignItems="center" sx={{padding:"0.5% 0%"}}>
          <Grid item>
        <Typography variant="h6" color="text.primary">
          Dashboard
        </Typography>
          </Grid>
          </Grid> */}
      <CardGroup totalMonthlyAmount={totalMonthlyAmount} repairs={repairs}
      currentVacancy={currentVacancy} inventoryCount={inventoryCount} totalAnnual={totalAnnual}
      totalMonthly_lastYear = {totalMonthly_lastYear} total_lastYear={total_lastYear}
      />
        <br></br>
        <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={8}>
          
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
        <FormControl sx={{ m: 1, width: 300 }}>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          onChange={(e)=>{
            setSearchStartDate(formatDate(e.target.value.startDate))
            setSearchEndDate(formatDate(e.target.value.endDate));
          }}
        >
          {last12Months.map((month)=>(
             <MenuItem value={month}>{month.startDate.toLocaleDateString('en-US', options) + " - " + 
              month.endDate.toLocaleDateString('en-US', options)}</MenuItem>
          ))}
          </Select>
          </FormControl>
        </Grid>
      </Grid>

        <ChartGroup 
        paymentReportSummary={reportSummary}
        annualPaymentSummary= {annualReport}
        avgRooms={avgRooms}
        occupancyReport={occupancyReport}
        searchStartDate={searchStartDate}
        searchEndDate={searchEndDate}
        callLogs={callLogs}
        totalCalls={totalCalls}
        expectedPayments={expectedPayments}
        receivedPayments={receivedPayments}
        />
      </Box>
      
      
      </>
    );


}
export default Dashboard;